import * as React from "react"
import {useTranslation} from "react-i18next";
import {useQuery} from "@apollo/react-hooks";
import {Box, SimpleGrid, Text, Badge, useColorModeValue} from "@chakra-ui/react";
import {SELECT_DIPLOMAS} from "../../backend/service/DiplomaQueries";
import {Link as RouterLink} from "react-router-dom";
import {Diploma} from "../../backend/entity/repository/Diploma";
import {truncateString} from "../../utilities/functions";

interface DiplomaGridProps {
    searchString: string
}

export function DiplomaGrid({searchString}: DiplomaGridProps) {
    const bg = useColorModeValue("gray.100", "gray.700")
    const color = useColorModeValue("gray.700", "gray.100")
    const {t} = useTranslation();
    const {loading, error, data} = useQuery(SELECT_DIPLOMAS, {
        pollInterval: 0,
    })

    function searchFiler(diploma: Diploma, searchString: string): boolean {
        return diploma.title.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) ||
            (diploma.number ? diploma.number.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) : false) ||
            diploma.study.title.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) ||
            diploma.study.name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) ||
            (diploma.catalog_number ? diploma.catalog_number.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()) : false) ||
            diploma.diploma_authors.some(da => da.person.last_name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) ||
            diploma.diploma_supervisors.some(ds => ds.employee.last_name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) ||
            diploma.diploma_reviewers.some(dr => dr.employee.last_name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()))
    }

    if (loading) return <p>{t('diploma_view.loading')}</p>;
    if (error) return <p>{t('diploma_view.error')}</p>;
    return (
        <SimpleGrid minChildWidth="280px" spacing="40px">
            {data.repository_diploma.filter((d: Diploma) => searchFiler(d, searchString)).map((diploma: Diploma) => (
                <RouterLink to={`view/` + diploma.filename}>
                    <Box color={color} bg={bg} borderRadius="md" p="2" height="396px">
                        <Box textTransform="uppercase" height="188px">
                            <Text fontSize="lg">{truncateString(diploma.title, 120, "...")}</Text>
                        </Box>
                        <Box d="flex" flexDirection="column" justifyContent="space-between" align="center"
                             height="178px">
                            <Box fontWeight="semibold">
                                {diploma.diploma_authors.map((author: any) => (
                                    <Box>{author.person.first_name} {author.person.last_name}</Box>
                                ))}
                            </Box>
                            <Box fontSize="xs" fontWeight="semibold">
                                {diploma.study.name} ({t("study." + diploma.study.level)})
                            </Box>
                            <Box>
                                {diploma.diploma_supervisors.map((supervisor: any) => (
                                    <Box
                                        fontSize="xs">Promotor: {supervisor.employee.degree_and_title.name} {supervisor.employee.first_name} {supervisor.employee.last_name}</Box>
                                ))}
                            </Box>
                            <Box>
                                {diploma.diploma_reviewers.map((reviewer: any) => (
                                    <Box
                                        fontSize="xs">Recenzent: {reviewer.employee.degree_and_title.name} {reviewer.employee.first_name} {reviewer.employee.last_name}</Box>
                                ))}
                            </Box>
                            <Box alignItems="baseline"
                                 color="gray.500"
                                 fontWeight="semibold"
                                 letterSpacing="wide"
                                 fontSize="xs"
                                 textTransform="uppercase"
                                 ml="2"
                            >
                                <Badge borderRadius="full" px="2" colorScheme="blue">
                                    {diploma.study.title}
                                </Badge>
                                {
                                    diploma.number ?
                                        <>
                                            &bull;
                                            <Badge borderRadius="full" px="2" colorScheme="red">
                                                {diploma.number}
                                            </Badge>
                                        </>
                                        :
                                        <>
                                        </>
                                }
                                {
                                    diploma.defense_date ?
                                        <>
                                            &bull;
                                            <Badge borderRadius="full" px="2" colorScheme="green">
                                                {diploma.defense_date}
                                            </Badge>
                                        </>
                                        :
                                        <>
                                        </>
                                }
                                {
                                    diploma.catalog_number ?
                                        <>
                                            &bull;
                                            <Badge borderRadius="full" px="2" colorScheme="yellow">
                                                {diploma.catalog_number}
                                            </Badge>
                                        </>
                                        :
                                        <>
                                        </>
                                }
                            </Box>
                        </Box>
                    </Box>
                </RouterLink>
            ))}
        </SimpleGrid>
    )
}

